import { HeadlessModal } from './HeadlessModal'
import { RadixModal } from './RadixModal'
import type { ModalProps } from './HeadlessModal'

export type { ModalProps } from './HeadlessModal'

export function Modal(props: ModalProps): React.ReactElement {
  if (props.useRadix) {
    return <RadixModal {...props} />
  }
  return <HeadlessModal {...props} />
}
